import { $api } from "../generated/client";

type UseRelatedReturnsParams = {
	returnRequestId: string;
	shopId: string;
};

export default function useRelatedReturns({
	returnRequestId,
	shopId,
}: UseRelatedReturnsParams) {
	const query = $api.useQuery(
		"get",
		"/shops/{shopId}/return-requests/{returnRequestId}/related",
		{
			params: {
				path: {
					returnRequestId,
					shopId,
				},
			},
		},
	);

	return query;
}
